// @flow
import React from "react";
import { NumberField } from "@quantum/ui";
import { Translate } from "@quantum/i18n";
import { connect } from "react-redux";
import {
  type ActionCreator,
  editarDiasUteisPeriodicidadeVolatilidade,
  getDiasUteisPeriodicidadeVolatilidadeSelecionado,
} from "../../../../state";
import { VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_VOLATILIDADE } from "../../../../model";

type Prop = {
  diasUteisPeriodicidadeVolatilidade: number,
  editarDiasUteisPeriodicidadeVolatilidade: ActionCreator,
};

function SelecaoDiasUteisPeriodicidadeVolatilidade({
  diasUteisPeriodicidadeVolatilidade,
  editarDiasUteisPeriodicidadeVolatilidade,
}: Prop) {
  function handleDiasUteisPeriodicidadeVolatilidadeEditado(
    diasUteisPeriodicidadeVolatilidade
  ) {
    editarDiasUteisPeriodicidadeVolatilidade(
      diasUteisPeriodicidadeVolatilidade
    );
  }

  function onBlur() {
    if (
      diasUteisPeriodicidadeVolatilidade !== 0 &&
      !diasUteisPeriodicidadeVolatilidade
    ) {
      editarDiasUteisPeriodicidadeVolatilidade(
        VALOR_DEFAULT_DIAS_UTEIS_PERIODICIDADE_VOLATILIDADE
      );
    }
  }

  return (
    <div>
      <Translate>Comum.DiasUteis</Translate>
      <NumberField
        allowNegative={false}
        onlyInteger={true}
        max={1000}
        min={1}
        onChangeValue={handleDiasUteisPeriodicidadeVolatilidadeEditado}
        value={diasUteisPeriodicidadeVolatilidade}
        thousandSeparator={""}
        onBlur={onBlur}
        className="ConfiguracaoMedida__input"
      />
    </div>
  );
}

export default connect(
  state => ({
    diasUteisPeriodicidadeVolatilidade: getDiasUteisPeriodicidadeVolatilidadeSelecionado(
      state
    ),
  }),
  { editarDiasUteisPeriodicidadeVolatilidade }
)(SelecaoDiasUteisPeriodicidadeVolatilidade);
